// 官方的元件
import Vue from 'vue'
import Router from 'vue-router'

// 載入自訂的元件(分頁)
import Main from '@/main.vue';
import Home from '@/components/home';
import Home_eng from '@/components/home_eng';
import Hotel from '@/components/pages/hotel';
import Transport from '@/components/pages/transport';
import Contractor from '@/components/pages/Contractor';
import Partners from '@/components/pages/partners';
import Member from '@/components/pages/member';
import MemberJoin from '@/components/pages/member_join';
import ForgetPassword from '@/components/pages/forget_password';
import SignUpRecord from '@/components/pages/signup_record';
import Modify from '@/components/pages/member_modify';
import Rules from '@/components/pages/rules';
import Sign from '@/components/pages/signup_sign';
import PrintFee from '@/components/pages/print_fee';
import PrintNoFee from '@/components/pages/print_nofee';
import ApplySuccess from '@/components/pages/apply_success';
import Contract from '@/components/pages/contract';
import ExhibitInfo from '@/components/pages/exhibit_info';

// 啟用元件
Vue.use(Router)

// 將元件匯出給進入點main.js
export default new Router({
  mode: 'history',
  base: '/', // /tlpartner/dist
  routes: [
    {
      name: '',  //元件的名稱
      path: '',     //對應的虛擬路徑
      component: Main,   //對應的元件
      children: [
        { name: 'home', path: '', component: Home },
        { name: 'home_eng', path: 'en', component: Home_eng },
        { name: 'exhibit_info', path: 'exhibit_info', component: ExhibitInfo },
        { name: 'hotel', path: 'hotel', component: Hotel },
        { name: 'transport', path: 'transport', component: Transport },
        { name: 'contractor', path: 'contractor', component: Contractor },
        { name: 'partners', path: 'partners', component: Partners },
        { name: 'member', path: 'member', component: Member },
        { name: 'member_join', path: 'member_join', component: MemberJoin },
        { name: 'forget_pwd', path: 'forget_pwd', component: ForgetPassword },
        { name: 'record', path: 'record', component: SignUpRecord },
        { name: 'modify', path: 'modify', component: Modify },
        { name: 'rules', path: 'rules', component: Rules },
        { name: 'sign', path: 'sign', component: Sign },
        { name: 'contract', path: 'contract', component: Contract }
      ]
    },
    {
      name: 'print_fee',
      path: '/print_fee',
      component: PrintFee
    },
    {
      name: 'print_nofee',
      path: '/print_nofee',
      component: PrintNoFee
    },
    {
      name: 'apply_success',
      path: '/apply_success',
      component: ApplySuccess
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js